import moment from 'moment'

export default class InternalScout {
  constructor(object) {
    this.cooperatedAt = moment.unix(object.cooperated_at)
    this.id = object.id
    this.memo = object.memo
    this.recruiterName = object.recruiter_name
    this.recruiterUrl = object.recruiter_url
  }
}
